'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/CatalogueResultItemButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CatalogueResultItemButton = function (_BcReactComponent) {
  _inherits(CatalogueResultItemButton, _BcReactComponent);

  function CatalogueResultItemButton(props) {
    _classCallCheck(this, CatalogueResultItemButton);

    var _this = _possibleConstructorReturn(this, (CatalogueResultItemButton.__proto__ || Object.getPrototypeOf(CatalogueResultItemButton)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(CatalogueResultItemButton, [{
    key: 'handleClick',
    value: function handleClick() {
      if (this.props.handleClick) {
        this.props.handleClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          screenReaderMessage = _props.screenReaderMessage,
          icon = _props.icon;

      return _react2.default.createElement(
        'div',
        { className: 'cp-catalogue-result-item-button' },
        _react2.default.createElement(
          _baseButtons.TextButton,
          {
            className: 'btn-ugc item-button',
            'data-test-id': 'item-button',
            flat: true,
            handleClick: this.handleClick },
          icon,
          _react2.default.createElement(
            'span',
            { 'aria-hidden': true },
            label
          ),
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            screenReaderMessage
          )
        )
      );
    }
  }]);

  return CatalogueResultItemButton;
}(_baseBcReactComponent2.default);

CatalogueResultItemButton.propTypes = {
  handleClick: _react.PropTypes.func,
  icon: _react.PropTypes.element,
  label: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
  screenReaderMessage: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element])
};

exports.default = CatalogueResultItemButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/catalogue-result-item-button/components/CatalogueResultItemButton.component.js
// module id = 977
// module chunks = 1